<div class="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-sm">
    <img alt="Zydia" class="mx-auto h-24 w-auto" src="logo_zydia_color.svg">
    <h2 class="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">Se connecter à votre compte</h2>
  </div>

  <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm space-y-4">

    @if (reason) {
      <div [class]="bannerClass" role="alert">
        <p class="text-sm font-medium">{{ bannerMessage }}</p>
      </div>
    }

    <button
      type="button"
      (click)="onLogin()"
      class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
      Se connecter
    </button>

    <p class="text-center text-sm text-gray-500">
      <a [href]="publicSiteUrl" class="font-semibold text-indigo-600 hover:text-indigo-500">Retour à {{ publicSiteHost }}</a>
    </p>

  </div>
</div>
